import { Pipe, PipeTransform } from '@angular/core';

import { ConfigService } from '../../../../core';
import { ConfigEmpresa, createNomeSecundarioRepresentante } from '../../../configuracoes/app/empresa';

@Pipe({
    name: 'representanteNomeSecundario'
})
/** Pipe utilizado para exibir o nome do representante conforme forma de identificação configurada pela empresa */
export class RepresentanteNomeSecundarioPipe implements PipeTransform {
    configEmpresa: ConfigEmpresa;

    constructor(private configService: ConfigService) {
        this.configEmpresa = this.configService.getEmpresa();
    }

    /** Retorna o nome secundário do Representante conforme a identificação do representante pela empresa selecionada na configuração da Empresa */
    transform(nome: string, nomeFantasia: string, codigoIntegracaoErp: string = null): string {
        return createNomeSecundarioRepresentante(this.configEmpresa.identificacaoRepresentante, nome, nomeFantasia, codigoIntegracaoErp);
    }
}
